import '@oddbird/popover-polyfill';
import { isSupported, isPolyfilled } from '@oddbird/popover-polyfill/fn';

import decode from './components/decode';
// import dialogs from './components/dialogs';
import disclose from './components/disclose';
import footer from './components/footer';
import inViewport from './components/in-viewport';
// import lazyBgImages from './components/lazy-bg-images';
import nav from './components/nav';
import navMobile from './components/nav-mobile';
// import promo from './components/promo';

// Minimal Shoelace integration
// 1. Shoelace installed via npm: npm install @shoelace-style/shoelace
// 2. CSS — themes/light.css imported via main-vendor.less
// 3. JS — individual components imported in main.js
// 4. Static assets – not needed/installed, they should be copied to /build and set setBasePath() accordingly
// https://shoelace.style/getting-started/installation#bundling
// https://shoelace.style/tutorials/integrating-with-laravel
import '@shoelace-style/shoelace/dist/components/tooltip/tooltip.js';

const ready = callback => {
    // Sanity check
	if (typeof callback !== 'function') return;
	// If document is already loaded, run method
	if (document.readyState === 'interactive' || document.readyState === 'complete') {
		return callback();
	}
	// Otherwise, wait until document is loaded
	document.addEventListener('DOMContentLoaded', callback, false);    
};

function init() {
	decode.init();
	// dialogs.init();
	disclose.init();
	footer.init();
	inViewport.init();
	// lazyBgImages.init();
	nav.init();
	navMobile.init();
	// promo.init();
}

ready(init);
